<template>
    <svg xmlns="http://www.w3.org/2000/svg" id="Vrstva_2" data-name="Vrstva 2" viewBox="0 0 203.55 197.08" :class="[sizeClass, spinning ? 'loader' : '']">
        <g id="Vrstva_1-2" data-name="Vrstva 1">
            <g id="Group_66" data-name="Group 66">
                <path id="Subtraction_2" data-name="Subtraction 2" class="fill-main" d="m82.82,197.08h0c-5.91-.91-11.73-2.33-17.4-4.23-5.57-1.89-10.97-4.26-16.12-7.1-7.51-4.11-14.43-9.22-20.58-15.19-6.09-5.98-11.34-12.76-15.6-20.16-4.37-7.55-7.68-15.65-9.84-24.1C1.06,117.47-.04,108.4,0,99.3c-.04-9.21,1.07-18.38,3.32-27.31,2.19-8.57,5.54-16.81,9.95-24.48,4.3-7.52,9.59-14.43,15.74-20.54,6.18-6.08,13.14-11.29,20.71-15.5,5.09-2.85,10.41-5.24,15.92-7.15,5.59-1.93,11.34-3.38,17.18-4.33v37.07c-4.38,1.33-8.58,3.16-12.53,5.47-4.59,2.67-8.79,5.96-12.5,9.77-3.75,3.9-6.98,8.28-9.6,13.02-2.73,4.93-4.79,10.2-6.11,15.67-1.38,5.81-2.07,11.77-2.04,17.75-.03,5.89.65,11.77,2.01,17.5,1.3,5.41,3.32,10.62,6.01,15.5,2.58,4.7,5.77,9.05,9.49,12.91,3.69,3.8,7.89,7.07,12.46,9.74,4.03,2.36,8.33,4.22,12.81,5.55v37.13h0Zm40.88-.71h0v-37.73c3.11-1.17,6.13-2.58,9.01-4.23,4.67-2.67,8.95-5.95,12.74-9.77,3.82-3.89,7.1-8.26,9.77-13.01,2.76-4.88,4.85-10.1,6.21-15.54,1.4-5.67,2.1-11.49,2.07-17.33.03-5.99-.66-11.96-2.04-17.78-1.33-5.51-3.38-10.81-6.11-15.78-2.61-4.78-5.87-9.18-9.67-13.08-3.76-3.81-8.04-7.08-12.71-9.7-2.97-1.68-6.08-3.1-9.28-4.27V.46c5.35,1,10.62,2.42,15.75,4.25,5.06,1.81,9.97,4.03,14.67,6.63,7.55,4.15,14.51,9.31,20.68,15.33,6.11,6.02,11.37,12.85,15.64,20.3,4.36,7.58,7.67,15.73,9.84,24.2,2.22,8.84,3.32,17.92,3.28,27.03.04,9.19-1.07,18.36-3.31,27.27-2.19,8.54-5.53,16.74-9.94,24.37-4.31,7.49-9.61,14.35-15.78,20.4-6.21,6.04-13.22,11.21-20.82,15.36-4.64,2.55-9.48,4.74-14.47,6.53-5.06,1.81-10.25,3.22-15.53,4.23h0Z"></path>
                <circle id="Ellipse_13" data-name="Ellipse 13" class="fill-main" cx="103.26" cy="98.47" r="19.44"></circle>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: 'Loader',
    props: {
        size: {
            type: [Number, String],
            default: 20
        },
        spinning: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        sizeClass() {
            return `size-${this.size}`;
        }
    },
}
</script>
<style scoped>
.loader {
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
}
</style>